// ----------------------------------------------------------------------------
// Snippet: Card
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/background-media/background-media';
import 'snippets/card-label/card-label';

// Styles
import './_card.scss';

// variables
const CARD_PRODUCT = '.card--product';
const CARD_META = '.card__meta';

const SELECTED_CLASS_NAME = 'selected';

const container = document.querySelector('.boost-sd__filter-product-list'); // Replace with your common ancestor selector

if (container != null) {

    container.addEventListener('mousemove', (event) => {
        if (window.innerWidth >= 1024) {
            const element = event.target.closest(CARD_META);
            if (element) {
                const buttonRect = element.getBoundingClientRect();
                const xPos = event.clientX - buttonRect.left;
                const yPos = event.clientY - buttonRect.top;
    
                element.style.background = `radial-gradient(circle at ${xPos}px ${yPos}px, rgba(53, 53, 53, 0.7) 0%, rgba(208, 208, 208, 0.00) 100%)`;
            }
        }
    });
    
    container.addEventListener('mouseleave', (event) => {
        if (window.innerWidth >= 1024) {
            const element = event.target.closest(CARD_META);
            if (element) {
                element.style.background = '#121212';
            }
        }
    });
}

document.querySelectorAll(CARD_META)
    .forEach((element) => {
        element.addEventListener('mousemove', (event) => {
            if (window.innerWidth >= 1024) {
                const buttonRect = element.getBoundingClientRect();
                const xPos = event.clientX - buttonRect.left;
                const yPos = event.clientY - buttonRect.top;
            
                element.style.background = `radial-gradient(circle at ${xPos}px ${yPos}px, rgba(53, 53, 53, 0.7) 0%, rgba(208, 208, 208, 0.00) 100%)`;
            }
        });

        element.addEventListener('mouseleave', () => {
            if (window.innerWidth >= 1024) {
                element.style.background = '#121212';
            }
        });
    });


// Inject Swatches stylings whenver there are card--with-swatches on the page using Section Rendering API
addEventListener('load', function() {
    const productCard = document.querySelector('.card--with-swatches');

    if (productCard) {
        
        fetch(window.location.pathname + "?sections=swatches")
            .then(res => res.json())
            .then((responseData) => {
                const headElement = document.head;
                headElement.insertAdjacentHTML('beforeend', responseData['swatches']);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
});

